import { SxProps, Theme } from '@mui/material';

import { proceduresContentHorizontalPaddingX } from 'components/StudyDashboard/studyDashboardSpacing';

export const adminPageContainerSx: SxProps<Theme> = {
  px: proceduresContentHorizontalPaddingX,
};

export const adminPageContainerMaxWidth = false;
